import theme from 'presentation/styles/theme'
import styled from 'styled-components'
// import AccordionNew from 'presentation/shared/components/AccordionNew'
import CardNew from 'presentation/shared/components/CardNew'

function getColor(color: string) {
  switch (color) {
    case 'green':
      return theme.colors.primary
    case 'purple':
      return theme.ds.colors.secondary800
    case 'gray':
      return theme.ds.colors.neutral500
    case 'orange':
      return theme.ds.colors.terciary700
    case 'blue':
      return theme.ds.colors.info400
    default:
      return theme.ds.colors.neutral500
  }
}

export const Wrapper = styled.div`
  display: flex;
  gap: 28px;
  height: 100%;
`

export const InformationsContainer = styled.div`
  flex-direction: column;
  display: flex;
  gap: 16px;
  height: 300px;
  flex: 1;

  .fc-day-today {
    background: transparent !important;
  }

  fc-button-group {
    display: flex;
    gap: 3px;
  }

  .fc-header-toolbar.fc-toolbar {
    margin-left: auto !important;
    gap: 5px;
  }

  .fc-button {
    background-color: ${({ theme }) => theme.colors.primary} !important;
  }

  .fc .fc-button-primary {
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: ${({ theme }) => theme.colors.primary};
    border: transparent;
    height: 30px;
    align-self: center;
    margin-left: 5px !important;
  }
`

export const SuperiorContainer = styled.div`
  padding: 20px;
  height: 240px;
  margin-bottom: 15px;
  border-radius: 1.1rem;
  background: ${({ theme }) => theme.colors.white};
`

export const EmptyState = styled(CardNew)`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  height: inherit;
  gap: 32px;
`

export const InferiorContainer = styled.div`
  padding: 20px 30px;
  /* height: 465px; */
  border-radius: 1.1rem;
  background: ${({ theme }) => theme.colors.white};
  display: block;
  place-self: center;
  justify-content: center;
  align-items: center;

  h1 {
    font-weight: ${({ theme }) => theme.font.bold};
    color: ${({ theme }) => theme.ds.colors.neutral400};
    font-size: ${({ theme }) => theme.ds.typography.size.small};
    margin-top: 20px;
    margin-bottom: 10px;
    text-align: center;
  }
`

export const Separator = styled.div`
  width: 1.1px;
  margin: 0 8px;
  background-color: #d1d3d7;
  justify-self: flex-end;
  align-self: stretch;
`

export const FlexContainer = styled.div`
  display: flex;
`

export const GridInfo = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
`

export const ContainerInfo = styled.div`
  display: block;
  align-items: center;
  font-size: ${({ theme }) => theme.font.sizes.xsmall};

  .patient-name {
    margin-bottom: 12px;
    width: max-content;
  }

  .patient-info {
    margin-bottom: 5px;
    width: max-content;
  }

  h1 {
    font-weight: ${({ theme }) => theme.font.bold};
    color: ${({ theme }) => theme.colors.gray};
    font-size: ${({ theme }) => theme.ds.typography.size.small};
    margin-bottom: 8px;
  }

  strong {
    font-weight: ${({ theme }) => theme.font.bold};
    color: ${({ theme }) => theme.colors.primary};
    font-size: ${({ theme }) => theme.ds.typography.size.small};
    margin-bottom: 8px;
  }

  a {
    color: ${({ theme }) => theme.colors.primary};
    font-size: ${({ theme }) => theme.ds.typography.size.small};
    font-weight: ${({ theme }) => theme.font.bold};
    margin-bottom: 8px;
    text-decoration: underline;
  }

  p {
    font-weight: ${({ theme }) => theme.font.bold};
    color: ${({ theme }) => theme.colors.mediumGray};
    font-size: ${({ theme }) => theme.ds.typography.size.xsmall};
    margin-bottom: 3px;
  }

  span {
    font-weight: ${({ theme }) => theme.font.light};
    color: ${({ theme }) => theme.colors.mediumGray};
    font-size: ${({ theme }) => theme.ds.typography.size.xsmall};
  }

  label {
    font-weight: ${({ theme }) => theme.font.normal};
    color: ${({ theme }) => theme.colors.gray};
  }

  & + & {
    margin-top: 4px;
  }
`

export const ModalInfo = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`

export const Title = styled.h3`
  font-size: ${({ theme }) => theme.font.sizes.medium};
  font-weight: ${({ theme }) => theme.font.bold};
  color: ${({ theme }) => theme.colors.neutralBlack};
`

export const ScrollContainer = styled.div`
  max-height: 500px;
  overflow: scroll;
  overflow-x: hidden;
`

export const ScrollTableContainer = styled.div`
  max-height: 300px;
  overflow: overlay;
  overflow-x: hidden;
`

export const Subtitle = styled.p`
  color: ${({ theme }) => theme.colors.neutralBlack};
  font-size: ${({ theme }) => theme.font.sizes.xsmall};
  font-weight: ${({ theme }) => theme.font.bold};
  line-height: 21px;
  letter-spacing: 0.5px;
  padding-bottom: 20px;
  text-align: left;

  p,
  li {
    overflow-wrap: break-word;
    color: ${({ theme }) => theme.colors.mediumGray};
    font-weight: ${({ theme }) => theme.font.semiBold};
  }
`

export const Label = styled.p`
  font-size: ${({ theme }) => theme.font.sizes.small};
  color: ${({ theme }) => theme.colors.neutralBlack};
  margin-bottom: 10px;
  text-align: left;
`

export const SoftText = styled.p`
  font-size: ${({ theme }) => theme.font.sizes.small};
  color: ${({ theme }) => theme.colors.mediumGray};
  font-weight: ${({ theme }) => theme.font.normal};
  text-align: left;
`

export const TableHeader = styled.table`
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  border-top: 2px solid ${({ theme }) => theme.colors.lightBlueishGreen};
  border-left: 2px solid ${({ theme }) => theme.colors.lightBlueishGreen};
  border-right: 2px solid ${({ theme }) => theme.colors.lightBlueishGreen};
  width: 100%;

  .description {
    text-align: left;
    padding-left: 10px;
  }

  .code {
    width: 95px;
  }

  td {
    font-size: ${({ theme }) => theme.font.sizes.xsmall};
  }

  th {
    width: 40px;
  }

  th:last-child {
    padding: 20px;
  }

  .header {
    width: 100%;
    background-color: ${({ theme }) => theme.colors.lightestBlueishGreen};
    font-size: ${({ theme }) => theme.font.sizes.xsmall};
    color: ${({ theme }) => theme.colors.primary};
    text-align: center;
  }

  tr {
    height: 56px;
    font-size: ${({ theme }) => theme.font.sizes.xsmall};
  }
`

export const Table = styled.table`
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  border-left: 2px solid ${({ theme }) => theme.colors.lightBlueishGreen};
  border-right: 2px solid ${({ theme }) => theme.colors.lightBlueishGreen};
  border-bottom: 2px solid ${({ theme }) => theme.colors.lightBlueishGreen};
  width: 100%;
  margin-bottom: 30px;

  .description {
    text-align: left;
    padding-left: 10px;
  }

  .code {
    width: 115px;
  }

  .trash {
    padding-right: 20px;
  }

  td {
    font-size: ${({ theme }) => theme.font.sizes.xsmall};
  }

  th {
    width: 40px;
  }

  th:last-child {
    padding: 20px;
  }

  tr {
    height: 56px;
    font-size: ${({ theme }) => theme.font.sizes.xsmall};
  }
`

export const ButtonPanel = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 10px;
  margin-top: 20px;

  button {
    width: 45%;
  }
`

export const RadioContainer = styled.div`
  display: flex;
  width: max-content;
  align-items: center;
`

export const SelectDateContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

export const Captions = styled.div`
  display: flex;
  margin-top: 20px;
`

export const Ball = styled.div`
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background-color: ${(props: any) => getColor(props.color)};
  margin-right: 4px;
`

export const SelectedRequestBall = styled.div`
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background-color: #b0b4bb;
  border: 2px solid #00e600;
  margin-right: 4px;
`

export const Caption = styled.div`
  display: flex;
  align-items: center;
  margin-right: 25px;
  span {
    font-weight: ${({ theme }) => theme.font.light};
    color: ${({ theme }) => theme.colors.mediumGray};
    font-size: ${({ theme }) => theme.ds.typography.size.xxsmall};
  }
`

export const FiltersContainer = styled(CardNew)`
  width: 420px;
`
